// @flow
export const adminFormFieldOrdered = [
  'location',
  'bookingType',
  'roomType',
  'yourName',
  'moveIn',
  'digitalVerification'
]

export const getDuration = (hasRestrictedDuration: string, location: Object) => {
  let result = []
  if (hasRestrictedDuration === 'restricted') {
    result = [
      {
        label: '12 months',
        value: 12
      },
      {
        label: '9 months',
        value: 9
      }
    ]
  } else if (hasRestrictedDuration === 'semi') {
    result = [
      {
        label: '12 months',
        value: 12
      },
      {
        label: '9 months',
        value: 9
      },
      {
        label: '6 months',
        value: 6
      }
    ]
  } else if (location && location.ref === 'tccw') {
    result = [
      {
        label: '12 months',
        value: 12
      },
      {
        label: '11 months',
        value: 11
      },
      {
        label: '10 months',
        value: 10
      },
      {
        label: '9 months',
        value: 9
      },
      {
        label: '8 months',
        value: 8
      },
      {
        label: '7 months',
        value: 7
      },
      {
        label: '6 months',
        value: 6
      },
      {
        label: '5 months',
        value: 5
      },
      {
        label: '4 months',
        value: 4
      },
      {
        label: '3 months',
        value: 3
      }
    ]
  } else {
    result = [
      {
        label: '12 months',
        value: 12
      },
      {
        label: '9 months',
        value: 9
      },
      {
        label: '6 months',
        value: 6
      },
      {
        label: '4 months',
        value: 4
      }
    ]
    // if (room && (room.ref === 'studio' || room.ref === 'ensuite')) {
    //   result.push({ label: '3 months', value: 3, weeklyPrice: price !== 0 ? price + 60 : 0 })
    // }
  }

  return result //result.map(r => ({ ...r, label: `${r.label} - £${r.weeklyPrice}/pw` }))
}



// WEBPACK FOOTER //
// ./src/containers/Admin/helpers.js